import { useCallback } from 'react'

import { CheckOutlined, GlobalOutlined } from '@ant-design/icons'
import { Button, Modal, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

export function LanguageSwitchModal({
  open,
  onClose = undefined,
}: {
  open: boolean
  onClose?: () => void | undefined
}) {
  const { t, i18n } = useTranslation('translation', {
    keyPrefix: 'components.LanguageSwitchModal',
  })

  const changeLanguage = useCallback(
    async (lng: string) => {
      await i18n.changeLanguage(lng)
      setTimeout(() => {
        if (onClose) {
          onClose()
        }
      }, 1000)
    },
    [i18n, onClose]
  )

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null} // フッターなしに設定
      centered
    >
      <Typography.Title
        level={4}
        className="flex items-center justify-center gap-x-2"
      >
        <GlobalOutlined style={{ fontSize: 30 }} />
        {t('title')}
      </Typography.Title>
      <div className="my-10 flex flex-col items-center gap-y-6">
        <Button
          className="w-full"
          type={i18n.language === 'ja' ? 'primary' : 'default'}
          icon={i18n.language === 'ja' ? <CheckOutlined /> : null}
          onClick={async () => {
            await changeLanguage('ja')
          }}
        >
          {t('japanese')}
        </Button>
        <Button
          className="w-full"
          type={i18n.language === 'en' ? 'primary' : 'default'}
          icon={i18n.language === 'en' ? <CheckOutlined /> : null}
          onClick={async () => {
            await changeLanguage('en')
          }}
        >
          {t('english')}
        </Button>
      </div>
    </Modal>
  )
}
